<div class="cb-margin flex-col flex" [ngClass]="{ 'mat-card': !inputFindDialogMode }">
    <mat-card-content>
        <form class="flex-col" #productCatalogueSearchForm="ngForm">
            <div class="flex-row space-between-center">
                <div class="flex-row start-center">
                    <cb-input
                        type="text"
                        name="searchFilter"
                        class="cb-margin-right-2x flex"
                        label="Keywords"
                        [maxlength]="100"
                        [allowEnterKeyEvents]="true"
                        (keydown.enter)="performSearch()"
                        [(ngModel)]="userCacheService.productCatalogSearch.data.query"
                    >
                    </cb-input>
                    <button
                        mat-icon-button
                        class="search-button cb-margin-right"
                        (click)="performSearch()"
                        title="Search"
                        [disabled]="searchIsLoading || !canPerformSearch()"
                    >
                        <mat-icon>search</mat-icon>
                    </button>
                    <cb-select
                        label="Filter Type"
                        class="cb-margin-right-2x filter-type flex"
                        name="productSearchTypeId"
                        [(ngModel)]="userCacheService.productCatalogSearch.data.productSearchTypeId"
                        (change)="productSearchTypeChanged()"
                        [options]="productSearchType"
                    >
                    </cb-select>
                    <div class="start-start flex-row">
                        <cb-checkbox
                            label="Active Only"
                            #isActiveComponent
                            (change)="toggleActiveOnly($event)"
                            class="cb-margin-right-2x flex"
                            name="activeOnly"
                            [(ngModel)]="userCacheService.productCatalogSearch.data.activeProducts"
                            [disabled]="activeOnlyIsLocked()"
                        >
                        </cb-checkbox>
                        <cb-checkbox
                            class="flex no-wrap cb-margin-right-2x"
                            label="Strict Search"
                            name="StrictSearch"
                            #isStrictSearch
                            (change)="toggleStrictSearch($event)"
                            style="height: 30px"
                            [(ngModel)]="userCacheService.productCatalogSearch.data.strictSearch"
                            >Strict Search
                        </cb-checkbox>
                        <cb-checkbox
                            class="flex no-wrap"
                            label="Show Only Null Rated"
                            name="showOnlyNullRated"
                            #isOnlyNullRatedComponent
                            (change)="toggleNullRated($event)"
                            [(ngModel)]="userCacheItem.data.nullRated"
                            [disabled]="nullRatedIsLocked()"
                        >
                        </cb-checkbox>
                    </div>
                </div>
                <div class="flex-row">
                    @if (canExportSearchResults()) {
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="exportToCsv()"
                            class="cb-margin-right-2x no-wrap"
                        >
                            Export to CSV
                        </button>
                    }
                    @if (canCreateProduct()) {
                        <div>
                            <button
                                mat-raised-button
                                color="primary"
                                [matMenuTriggerFor]="actionsMenu"
                            >
                                Create new Item
                            </button>
                            <mat-menu #actionsMenu>
                                @for (type of productTypes; track type) {
                                    <button mat-menu-item (click)="openCreate(type.id, $event)">
                                        {{ type.label }}
                                    </button>
                                }
                            </mat-menu>
                        </div>
                    }
                </div>
            </div>
            @if (filterChips && filterChips.length > 0) {
                <div class="start-center flex-row">
                    <mat-chip-set>
                        @for (chip of filterChips; track chip; let index = $index) {
                            <mat-chip (removed)="removeChip(chip)">
                                <strong class="mat-body-2">{{ chip.text }}</strong>
                                <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip>
                        }
                    </mat-chip-set>
                </div>
            }
            <div class="flex-wrap flex">
                <div class="cb-margin-bottom-2x cb-margin-right-2x lt-lg-100 flex-33">
                    @if (cachedSelectedCategories) {
                        <cb-category-filter
                            class="flex"
                            (change)="setSelectedCategory($event)"
                            name="selectedCategories"
                            [cachedSelectedCategories]="cachedSelectedCategories"
                            [(ngModel)]="
                                userCacheService.productCatalogSearch.data.selectedCategories
                            "
                            [restrictedCategories]="restrictedCategories"
                            [isFetching]="isFetching$ | async"
                        >
                        </cb-category-filter>
                    }
                </div>
                <div class="lt-lg-100 flex">
                    <cb-table
                        class="cb-margin-top"
                        label="Product Catalogue Items"
                        maxHeightOffset="313"
                        [objectColumns]="columns"
                        [loaded]="true"
                        [fetch]="fetchSearchResults()"
                        [queryUpdated]="queryUpdate"
                        [infiniteScrollEnabled]="userCacheItem?.resolved"
                        [(currentPage)]="currentPage"
                        [(results)]="searchResults"
                        (fetchInProgressChange)="isFetching$.next($event)"
                    >
                        <tbody cbTableBody>
                            @for (product of searchResults; track product) {
                                <tr>
                                    <td>
                                        @if (product.isCompositeItemWithoutAssignedItems) {
                                            <cb-td-icon
                                                svgValue="hexagon-outline"
                                                toolTip="Composite Item with no Items Assigned"
                                            >
                                            </cb-td-icon>
                                        }
                                        @if (product.isCompositeItemWithAssignedItems) {
                                            <cb-td-icon
                                                svgValue="hexagon-slice-6"
                                                toolTip="Composite Item with Items Assigned"
                                            >
                                            </cb-td-icon>
                                        }
                                        @if (product.compositeItemId) {
                                            <cb-td-icon
                                                svgValue="hexagon-slice-1"
                                                toolTip="Assigned to Composite Item"
                                            >
                                            </cb-td-icon>
                                        }
                                        @if (product.hasImage) {
                                            <cb-td-icon value="photo" toolTip="Has Image">
                                            </cb-td-icon>
                                        }
                                        @if (product.inSpec) {
                                            <cb-td-icon value="style" toolTip="Is in Spec">
                                            </cb-td-icon>
                                        }
                                        @if (product.manualColourEntryRequired) {
                                            <cb-td-icon
                                                value="format_paint"
                                                toolTip="Manual Colour Entry Required"
                                            >
                                            </cb-td-icon>
                                        }
                                        @if (product.showInColourYourDreams) {
                                            <cb-td-icon
                                                value="book_open_page_variant"
                                                toolTip="Show in Colour Schedule"
                                            >
                                            </cb-td-icon>
                                        }
                                    </td>
                                    <td>{{ product?.code }}</td>
                                    <td>
                                        {{ product?.name }}
                                        @if (product.isStandardProduct) {
                                            <cb-display-pill
                                                [displayPillText]="'Standard'"
                                            ></cb-display-pill>
                                        }
                                    </td>
                                    <td>{{ product?.uomDisplay }}</td>
                                    <cb-td-currency
                                        [value]="product?.nationalRate"
                                    ></cb-td-currency>
                                    <td>{{ product.mainCategory }}</td>
                                    <cb-td-checkbox [value]="product?.isActive"></cb-td-checkbox>
                                    @if (!inputFindDialogMode) {
                                        <td cbTableShrinkCol cbTableStickyCol="end">
                                            <button
                                                mat-icon-button
                                                matTooltip="View Product"
                                                class="cb-margin-right"
                                                (click)="viewProduct(product, $event)"
                                            >
                                                <mat-icon>pageview</mat-icon>
                                            </button>
                                            <button
                                                mat-icon-button
                                                matTooltip="Edit Product"
                                                (click)="openEdit(product)"
                                            >
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </td>
                                    }
                                    @if (inputFindDialogMode) {
                                        <td cbTableShrinkCol cbTableStickyCol="end">
                                            <button
                                                mat-icon-button
                                                matTooltip="Select Product"
                                                (click)="selectProduct(product)"
                                            >
                                                <mat-icon>pageview</mat-icon>
                                            </button>
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </cb-table>
                </div>
            </div>
        </form>
    </mat-card-content>
</div>
